import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { IUser } from 'types/users.types';

const fakeFilesMap: Record<string, string | undefined> = {
  de_en: 'de.pdf',
  de_de: 'de.pdf',
  be_en: 'fr.pdf',
  be_fr: 'fr.pdf',
  be_nl: 'nl.pdf',
};

export const getFakeInvoiceLink = (fileName: string) =>
  window.origin + '/' + fileName;

const useCreateFakeReceipt = () => {
  const user = useGetCurrentCustomerData().data as IUser;

  const {
    i18n: { language },
  } = useTranslation();

  const invoiceFile =
    fakeFilesMap[`${user.country}_${language}`] || fakeFilesMap.be_en;

  const createFakeInvoice = useCallback(
    async (onCreated: (file: File, invoiceFile: string) => void) => {
      if (!invoiceFile) return;
      const file = await fetch(getFakeInvoiceLink(invoiceFile))
        .then((res) => res.blob())
        .then(
          (blob) =>
            new File([blob], invoiceFile, {
              type: 'application/pdf',
            }),
        );

      onCreated(file, `${invoiceFile}${new Date().toISOString()}`);
    },
    [invoiceFile],
  );

  return { createFakeInvoice, receiptFile: invoiceFile };
};

export default useCreateFakeReceipt;
